export default {
    PENDENTE_ENVIO_DRS: 1,
    PENTENDE_RETIRADA_DRS: 2,
    PENDENTE_RETIRADA_PACIENTE: 3,
    RETIRADO_PACIENTE: 4,
    PROCESSO_DEVOLVIDO: 5,
    NAO_RETIRADO: 6,
}